import { Box } from '@mui/material';
import { BarChart } from '@mui/x-charts';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import React from 'react'
import Graphs from '../components/graphs';

export default function Test() {

    let data: any = [
        {
            "Bank_Name": "CIMB",
            "Year": 2021,
            "Average_Net_Profit": 4295334000
        },
        {
            "Bank_Name": "CIMB",
            "Year": 2022,
            "Average_Net_Profit": 5592931000
        },
        {
            "Bank_Name": "Maybank",
            "Year": 2021,
            "Average_Net_Profit": 8096200000
        },
        {
            "Bank_Name": "Maybank",
            "Year": 2022,
            "Average_Net_Profit": 8235000000
        }
    ];


      return (
        <Graphs
        data={data}
        type='bar chart'
        
        />
      );
}
